<template>
  <div
    class="step-matrix-header"
    >
    <slot/>
  </div>
</template>
<script>
  export default {
    props: [],
    data: () => ({
    }),
  }
</script>
<style>
  .step-matrix-header {
    width: 24px;
    /* transform: rotate(-90deg); */
    /* background-color: red; */
    overflow: visible;
    text-overflow: visible;
    transform: rotate(-45deg) translateX(50%);
    white-space: nowrap;
  }
</style>
